@file:OptIn(InternalResourceApi::class)

package mifos_mobile.core.designsystem.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/mifos_mobile.core.designsystem.generated.resources/"

public val Res.font.inter_black: FontResource by lazy {
      FontResource("font:inter_black", setOf(
        ResourceItem(setOf(), "${MD}font/inter_black.ttf", -1, -1),
      ))
    }

public val Res.font.inter_bold: FontResource by lazy {
      FontResource("font:inter_bold", setOf(
        ResourceItem(setOf(), "${MD}font/inter_bold.ttf", -1, -1),
      ))
    }

public val Res.font.inter_extra_bold: FontResource by lazy {
      FontResource("font:inter_extra_bold", setOf(
        ResourceItem(setOf(), "${MD}font/inter_extra_bold.ttf", -1, -1),
      ))
    }

public val Res.font.inter_extra_light: FontResource by lazy {
      FontResource("font:inter_extra_light", setOf(
        ResourceItem(setOf(), "${MD}font/inter_extra_light.ttf", -1, -1),
      ))
    }

public val Res.font.inter_light: FontResource by lazy {
      FontResource("font:inter_light", setOf(
        ResourceItem(setOf(), "${MD}font/inter_light.ttf", -1, -1),
      ))
    }

public val Res.font.inter_medium: FontResource by lazy {
      FontResource("font:inter_medium", setOf(
        ResourceItem(setOf(), "${MD}font/inter_medium.ttf", -1, -1),
      ))
    }

public val Res.font.inter_regular: FontResource by lazy {
      FontResource("font:inter_regular", setOf(
        ResourceItem(setOf(), "${MD}font/inter_regular.ttf", -1, -1),
      ))
    }

public val Res.font.inter_semi_bold: FontResource by lazy {
      FontResource("font:inter_semi_bold", setOf(
        ResourceItem(setOf(), "${MD}font/inter_semi_bold.ttf", -1, -1),
      ))
    }

public val Res.font.inter_thin: FontResource by lazy {
      FontResource("font:inter_thin", setOf(
        ResourceItem(setOf(), "${MD}font/inter_thin.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("inter_black", Res.font.inter_black)
  map.put("inter_bold", Res.font.inter_bold)
  map.put("inter_extra_bold", Res.font.inter_extra_bold)
  map.put("inter_extra_light", Res.font.inter_extra_light)
  map.put("inter_light", Res.font.inter_light)
  map.put("inter_medium", Res.font.inter_medium)
  map.put("inter_regular", Res.font.inter_regular)
  map.put("inter_semi_bold", Res.font.inter_semi_bold)
  map.put("inter_thin", Res.font.inter_thin)
}
